import { IRotatedRect } from './geometry';

export const fillRotatedRect = (ctx: CanvasRenderingContext2D, rect: IRotatedRect) => {
	if (rect.rotation === 0) {
		ctx.fillRect(
			rect.center.x - rect.size.x * 0.5,
			rect.center.y - rect.size.y * 0.5,
			rect.size.x,
			rect.size.y
		);
	} else {
		ctx.save();
		ctx.translate(rect.center.x, rect.center.y);
		ctx.rotate((rect.rotation * Math.PI) / 180);
		ctx.fillRect(-rect.size.x * 0.5, -rect.size.y * 0.5, rect.size.x, rect.size.y);
		ctx.restore();
	}
};

export const fillRotatedRectOval = (ctx: CanvasRenderingContext2D, rect: IRotatedRect) => {
	ctx.beginPath();
	ctx.ellipse(
		rect.center.x,
		rect.center.y,
		Math.abs(rect.size.x * 0.5),
		Math.abs(rect.size.y * 0.5),
		(rect.rotation * Math.PI) / 180,
		0,
		Math.PI * 2
	);
	ctx.fill();
};

export const fillRotatedRectTriangle = (ctx: CanvasRenderingContext2D, rect: IRotatedRect) => {
	ctx.save();
	ctx.translate(rect.center.x, rect.center.y);
	ctx.rotate((rect.rotation * Math.PI) / 180);
	ctx.beginPath();
	ctx.moveTo(0, rect.size.y * 0.5);
	ctx.lineTo(-rect.size.x * 0.5, -rect.size.y * 0.5);
	ctx.lineTo(rect.size.x * 0.5, -rect.size.y * 0.5);
	ctx.closePath();
	ctx.fill();
	ctx.restore();
};

export const drawRotatedRectImage = (
	ctx: CanvasRenderingContext2D,
	rect: IRotatedRect,
	image: CanvasImageSource
) => {
	ctx.save();
	ctx.translate(rect.center.x, rect.center.y);
	ctx.rotate((rect.rotation * Math.PI) / 180);
	ctx.scale(1, -1);
	ctx.drawImage(image, -rect.size.x * 0.5, -rect.size.y * 0.5, rect.size.x, rect.size.y);
	ctx.restore();
};

export const drawRotatedRectImageWithTextAbove = (
	ctx: CanvasRenderingContext2D,
	rect: IRotatedRect,
	image: CanvasImageSource,
	text: string,
) => {
	ctx.save();
	ctx.translate(rect.center.x, rect.center.y);
	ctx.rotate((rect.rotation * Math.PI) / 180);
	ctx.scale(1, -1);
	ctx.drawImage(image, -rect.size.x * 0.5, -rect.size.y * 0.5, rect.size.x, rect.size.y);
	const textMerics = ctx.measureText(text);
	ctx.fillText(text, -textMerics.width * 0.5, -rect.size.y * 0.5 - 8);
	ctx.restore();
};

export const strokeRotatedRect = (ctx: CanvasRenderingContext2D, rect: IRotatedRect) => {
	if (rect.rotation === 0) {
		ctx.strokeRect(
			rect.center.x - rect.size.x * 0.5,
			rect.center.y - rect.size.y * 0.5,
			rect.size.x,
			rect.size.y
		);
	} else {
		ctx.save();
		ctx.translate(rect.center.x, rect.center.y);
		ctx.rotate((rect.rotation * Math.PI) / 180);
		ctx.strokeRect(-rect.size.x * 0.5, -rect.size.y * 0.5, rect.size.x, rect.size.y);
		ctx.restore();
	}
};

export const strokeFillRoundedRotatedRect = (ctx: CanvasRenderingContext2D, rect: IRotatedRect, radius: number) => {
	if (rect.rotation === 0) {
		ctx.beginPath();
		ctx.roundRect(
			rect.center.x - rect.size.x * 0.5,
			rect.center.y - rect.size.y * 0.5,
			rect.size.x,
			rect.size.y,
			radius,
		);
		ctx.fill();
		ctx.stroke();
	} else {
		ctx.save();
		ctx.translate(rect.center.x, rect.center.y);
		ctx.rotate((rect.rotation * Math.PI) / 180);
		ctx.roundRect(
			rect.center.x - rect.size.x * 0.5,
			rect.center.y - rect.size.y * 0.5,
			rect.size.x,
			rect.size.y,
			radius,
		);
		ctx.fill();
		ctx.stroke();
		ctx.restore();
	}
};

export const clipRoundedRotatedRect = (ctx: CanvasRenderingContext2D, rect: IRotatedRect, radius: number) => {
	if (rect.rotation === 0) {
		ctx.beginPath();
		ctx.roundRect(
			rect.center.x - rect.size.x * 0.5,
			rect.center.y - rect.size.y * 0.5,
			rect.size.x,
			rect.size.y,
			radius,
		);
		ctx.clip();
	} else {
		ctx.save();
		ctx.translate(rect.center.x, rect.center.y);
		ctx.rotate((rect.rotation * Math.PI) / 180);
		ctx.roundRect(
			rect.center.x - rect.size.x * 0.5,
			rect.center.y - rect.size.y * 0.5,
			rect.size.x,
			rect.size.y,
			radius,
		);
		ctx.clip();
		ctx.restore();
	}
};


export const createTintedImageCanvas = (
	image: HTMLImageElement | null,
	color: string
): HTMLCanvasElement | null => {
	if (image === null) return null;

	let canvas = document.createElement('canvas');
	canvas.width = image.width;
	canvas.height = image.height;

	let ctx = canvas.getContext('2d');
	if (ctx === null) return null;

	ctx.fillStyle = color;
	ctx.fillRect(0, 0, image.width, image.height);
	ctx.globalCompositeOperation = 'destination-in';
	ctx.drawImage(image, 0, 0);

	return canvas;
};
